// extracted by mini-css-extract-plugin
export default {"TaglineItem":"TaglineItem_TaglineItem__bpJq1"};